import { createSlice } from "@reduxjs/toolkit";
import { STAUTES } from "../../../../utils/constant";
import { getApi } from "../../../../utils/services";
import { GET_ALL_PERMISSIONS } from "../../../../utils/services/apiPath";
import { addReferenceToPermission, getPermissionFromLocalStorage, setPermissionToLocalStorage } from "../../DataTransformer/permissionTransformer";
import {
  R_DASHBOARD,
  R_PARTNERS,
  R_PROJECTS,
  R_EMPLOYEES,
  R_RAP_MGMT,
  R_REPORTS,
  R_SETTINGS,
  R_NOTES,
  R_DOCUMENTS,
  R_PROFILE,
  R_SOCIAL_MEDIA,
  R_PARTNERS_PROFILE,
  R_PARTNERS_NOTES,
  R_PARTNERS_SOCIALMEDIA,
  R_PARTNERS_LOCATION,
  R_PARTNERS_LIST,
  R_PARTNERS_CONTACTS,
  R_PARTNERS_DOCUMENTS,
  R_EMPLOYEES_LIST,
  R_TIME_SHEET,
  R_RAP_MGMT_LIST,
  R_RAP_MGMT_APPRENTICE,
  R_RAP_MGMT_STATUS,
  R_RAP_MGMT_WAGE_SCALE,
  R_PROJECTS_JOBS,
  R_TOP_NAVIGATION,
  R_APPRENTICE_180_RAP,
  R_APPRENTICE_180,
  R_APPRENTICE_180_SPONSOR_INFO,
  R_RAP_MGMT_MENTOR_POOL,
  R_ALL_DOCUMENTS,
  R_DOCUMENTS_671_FORM
} from "../../../../utils/permissionReferenceConfig";

const initialState = {
  permissions: {},
  permissionStatus: STAUTES.IDLE,
  permissionLoaded: false,
  message: ""
};

export const getAllPermissions = forcedRefresh => {
  return async dispatch => {
    if (!forcedRefresh && localStorage.getItem("permissions")) {
      try {
        return dispatch(SET_PERMISSION(getPermissionFromLocalStorage()));
      } catch (error) {
        localStorage.removeItem("permissions");
        getAllPermissions(true);
      }
    }
    dispatch(SET_STATUS(STAUTES.LOADING));
    const res = await getApi(GET_ALL_PERMISSIONS);
    if (res.error) return dispatch(SET_MESSAGE(res.error));
    setPermissionToLocalStorage(res.data);
    dispatch(SET_PERMISSION(res.data));
    dispatch(SET_STATUS(STAUTES.IDLE));
  };
};

const permissionSlice = createSlice({
  name: "permission",
  initialState,
  reducers: {
    SET_PERMISSION: (state, action) => {
      state.permissions = addReferenceToPermission(action.payload || []);
      state.permissionLoaded = true;
    },
    SET_STATUS: (state, action) => {
      state.permissionStatus = action.payload;
    },
    SET_MESSAGE: (state, action) => {
      state.message = action.payload;
      state.permissionStatus = STAUTES.ERROR;
    },
    REMOVE_PERMISSION: state => {
      state.permissions = {};
      state.permissionLoaded = false;
    }
  }
});

export const { SET_PERMISSION, REMOVE_PERMISSION, SET_STATUS, SET_MESSAGE, SET_PERMISSION_LOADED } = permissionSlice.actions;

const createPermissionSelector = (module, subModule) => state =>
  subModule ? state.permissions.permissions?.[module]?.subModulePermissions?.[subModule] || {} : state.permissions.permissions?.[module] || {};

export const allPermissionSelector = state => state.permissions;
export const dashboardPermissionSelector = createPermissionSelector(R_DASHBOARD);
export const topNavigationPermissionSelector = createPermissionSelector(R_TOP_NAVIGATION);
export const partnersPermissionSelector = createPermissionSelector(R_PARTNERS);
export const partnersProfilePermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_PROFILE);
export const partnersContactPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_CONTACTS);
export const partnersDocumentPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_DOCUMENTS);
export const partnersNotesPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_NOTES);
export const partnersSocialMediaPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_SOCIALMEDIA);
export const partnersLocationPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_LOCATION);
export const projectsPermissionSelector = createPermissionSelector(R_PROJECTS);
export const projectsJobsPermissionSelector = createPermissionSelector(R_PROJECTS, R_PROJECTS_JOBS);
export const rapPermissionSelector = createPermissionSelector(R_RAP_MGMT);
export const reportsPermissionSelector = createPermissionSelector(R_REPORTS);
export const settingsPermissionSelector = createPermissionSelector(R_SETTINGS);
export const documentsPermissionSelector = createPermissionSelector(R_ALL_DOCUMENTS);

// Employees
export const employeesPermissionSelector = createPermissionSelector(R_EMPLOYEES);
export const employeesListPermissionSelector = createPermissionSelector(R_EMPLOYEES, R_EMPLOYEES_LIST);
export const employeesNotesPermissionSelector = createPermissionSelector(R_EMPLOYEES, R_NOTES);
export const employeesDocumentsPermissionSelector = createPermissionSelector(R_EMPLOYEES, R_DOCUMENTS);
export const employeesProfilePermissionSelector = createPermissionSelector(R_EMPLOYEES, R_PROFILE);
export const employeesSocialMediaPermissionSelector = createPermissionSelector(R_EMPLOYEES, R_SOCIAL_MEDIA);
export const partnersListPermissionSelector = createPermissionSelector(R_PARTNERS, R_PARTNERS_LIST);
export const employeesTimeSheetPermissionSelector = createPermissionSelector(R_EMPLOYEES, R_TIME_SHEET);
export const rapMgmtPermissionSelector = createPermissionSelector(R_RAP_MGMT, R_RAP_MGMT_LIST);
export const rapMgmtMentorPoolPermissionSelector = createPermissionSelector(R_RAP_MGMT, R_RAP_MGMT_MENTOR_POOL);
export const rapMgmtApprenticePermissionSelector = createPermissionSelector(R_RAP_MGMT, R_RAP_MGMT_APPRENTICE);
export const rapMgmtStatusPermissionSelector = createPermissionSelector(R_RAP_MGMT, R_RAP_MGMT_STATUS);
export const rapMgmtWageScalePermissionSelector = createPermissionSelector(R_RAP_MGMT, R_RAP_MGMT_WAGE_SCALE);

// Apprentice 180
export const apprenticeRapPermissionSelector = createPermissionSelector(R_APPRENTICE_180, R_APPRENTICE_180_RAP);
export const apprenticeSponsorInfoPermissionSelector = createPermissionSelector(R_APPRENTICE_180, R_APPRENTICE_180_SPONSOR_INFO);

//671 Form
export const form671PermissionSelector = createPermissionSelector(R_ALL_DOCUMENTS, R_DOCUMENTS_671_FORM);

//dynamic permission selector
export const subModPermissionSelector = (module, subModule) => state =>
  state.permissions.permissions?.[module]?.subModulePermissions?.[subModule] || {};

export default permissionSlice.reducer;
